import { classNames } from "../../../../../tool";
import styles from "../index.module.scss";
import { useState } from "react";
export default function ZMYL(props) {
  const { selectPlays, onBet, firstPlay, playOddInfo } = props;
  const plays = firstPlay.children;
  const [closeIndex, setCloseIndex] = useState([]);
  return (
    <div className={styles.playContainer}>
      {plays.map((item, index) => {
        const closeIdx = closeIndex.findIndex((i) => i === index);
        const isClose = closeIdx !== -1;
        return (
          <div key={index} className={styles.playItemContainer}>
            <div
              className={styles.playItemTitle}
              onClick={() => {
                const newClose = JSON.parse(JSON.stringify(closeIndex));
                if (isClose) {
                  newClose.splice(closeIdx, 1);
                } else {
                  newClose.push(index);
                }
                setCloseIndex(newClose);
              }}
            >
              <span>{item.name}</span>
              <img
                className={classNames(
                  styles.icon,
                  isClose ? styles.iconClose : ""
                )}
                src={require("../../../../../assets/imgs/new/iocn_collapse.png")}
              />
            </div>
            <div
              className={classNames(
                styles.playItemContent,
                isClose ? styles.playItemContentClose : ""
              )}
            >
              {item.plays.map((it, idx) => {
                const active =
                  selectPlays.findIndex(
                    (i) => i.code === it.code && item.code === i.secondCode
                  ) !== -1;
                return (
                  <div
                    key={index + idx}
                    className={classNames(
                      styles.playItem,
                      styles.ZMYL,
                      idx === item.plays.length - 4 ? styles.last : "",
                      active ? styles.active : ""
                    )}
                    onClick={() => onBet(it, item)}
                  >
                    <div className={styles.name}>{it.name}</div>
                    <div className={styles.odds}>
                      {
                        playOddInfo[
                          `LHC_${firstPlay.code}_${item.code}${it.code}`
                        ]
                      }
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
